/**
 *      Progress indicator
 **/
function progressBarRecalc() {
    var progressBar = document.querySelector('.progress-bar .bar .progress');
    if (progressBar) {
        progressBar.style.width = ((window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100) + "%";
    }
}
progressBarRecalc();

document.addEventListener("DOMContentLoaded", function () {
    window.addEventListener("scroll", progressBarRecalc);
    window.addEventListener("orientationchange", progressBarRecalc);
    window.addEventListener("resize", progressBarRecalc);
});